export const SECONDS = 60;
export const MILLI_SECONDS = 1000;
export const ONE_DAY_IN_MINUTES = 24 * 60;

export const queryStaleTime = (minutes = 5): number =>
  minutes * SECONDS * MILLI_SECONDS;

export const tenMinutes = queryStaleTime(10);
export const fiveMinutes = queryStaleTime(5);
export const oneDay = queryStaleTime(ONE_DAY_IN_MINUTES);
export const oneHour = queryStaleTime(60);

export const HOME_QUERY_KEY = 'home';

export const ALL_FIELDS_QUERY_KEY = ['all-fields'];
export const TASK_FIELDS_QUERY_KEY = ['task-fields'];
export const FINANCIAL_FIELDS_QUERY_KEY = ['financial-fields'];
export const PROJECT_STATUS_FIELD_QUERY_KEY = ['project-status-field'];
export const SPRINT_FIELD_QUERY_KEY = ['sprint-fields'];
export const SKILL_FIELDS_FOR_READ_ACCESS_QUERY_KEY = 'skill-fields-for-read';

export const ALL_PROJECTS_QUERY_KEY = ['all-projects'];
export const ALL_PROJECTS_RM_QUERY_KEY = ['all-projects-rm'];
export const ARCHIVED_PROJECTS_QUERY_KEY = ['archived-projects'];
export const PROJECTS_META_QUERY_KEY = ['projects-meta'];
export const ALL_PROJECT_CURRENT_PHASES_QUERY_KEY = [
  'all-project-current-phases',
];
